export const transformSerialTimestamp = (serial: string, position: number, timestamp: number) => {
    if (!/^[A-Za-z0-9]+$/.test(serial)) {
        throw new Error("Serial inválido");
    }
    if (typeof position !== "number" || position < 1 || position > 9) {
        throw new Error("La posición debe estar entre 1 y 9");
    }
    // Paso 1: obtener los últimos 5 caracteres y extraer los dígitos
    const lastFive = serial.slice(-5);
    const digitsOnly = lastFive.replace(/\D/g, '');
    const A = parseInt(digitsOnly, 10) || 0;
    const timestampStr = String(timestamp);
    const insertion = '0'.repeat(A);
    // :llave_de_tuerca: ¡Ajustar correctamente el índice! La posición es en base 1
    const posIndex = position; // <-- Este es el FIX (ya que slice permite hasta el último índice sin romper)
    const result =
        timestampStr.slice(0, posIndex) + insertion + timestampStr.slice(posIndex);
    return result;
}




